import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import moment from 'moment-timezone';

import {withI18n} from 'spa/Components/Context';

import {cn} from 'spa/css';

import ReviewBox, { ReviewBoxType, ReviewBoxStarSize } from '@urbanmassage/component-library/lib/ReviewBox/ReviewBox';

import './text-reviews.less';

@observer
@withI18n
class TextReviews extends React.Component {
  static propTypes = {
    bordered: PropTypes.bool,
    disableFirstBordered: PropTypes.bool,
    reviews: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
      })),
      PropTypes.object,
    ]).isRequired,
    smallStars: PropTypes.bool,
  }

  static defaultProps = {
    bordered: false,
    smallStars: false,
  }

  render() {
    const {i18n} = this.context;
    const {
      bordered, disableFirstBordered, reviews, smallStars,
    } = this.props;

    if (reviews && reviews.length < 1 || !reviews) return null;

    return (
      <ul className="text-reviews__reviews-list">
        {reviews.map((review, index) => (
          <li
            className={cn(
              'text-reviews__reviews-list-item',
              !bordered && 'text-reviews__reviews-list-item--top-border',
              disableFirstBordered && index === 0 && 'text-reviews__reviews-list-item--disable-top-border',
            )}
            key={`${review.id}-promoted_review_item_element`}
          >
            <ReviewBox
              key={`${review.id}-promoted_review_item`}
              rating={review.rating}
              reviewText={review.content}
              verifiedLabelText={i18n._x('Verified review', 'Promoted Review label')}
              showVerifiedLabel
              secondaryText={[moment(review.createdAt).fromNow().toString(), review.specialityName]}
              reviewBoxType={bordered && ReviewBoxType.box}
              starSize={smallStars && ReviewBoxStarSize.small}
            />
          </li>
        ))}
      </ul>
    );
  }
}

export default TextReviews;



// WEBPACK FOOTER //
// ./spa/Components/Reviews/TextReviews.jsx